import http from "./axios";

// 查询列表
const queryPage = ({ name, enabled }) => {
  return http.get("/manager/platform/list", {
    name,
    enabled,
  });
};

const queryImageList = () => {
  return http.get("/manager/platform/queryImageList");
};

const passRate = ({ platformId }) => {
  return http.get("/manager/platform/passRate", { platformId });
};

const areaList = () => {
  return http.get("/manager/platform/areaList");
};

const getPreCheckCity = ({ platformId }) => {
  return http.get("/manager/platform/getPreCheckCity", { platformId });
};

const getPreCheckList = ({ platformId }) => {
  return http.get("/manager/platform/getPreCheckList", { platformId });
};

const addPreCheck = ({
  minAge,
  maxAge,
  cityList,
  optionalList,
  preclusiveList,
  apiTimeStart,
  apiTimeEnd,
  platformId,
}) => {
  return http.json_post("/manager/platform/addPreCheck", {
    minAge,
    maxAge,
    cityList,
    optionalList,
    preclusiveList,
    apiTimeStart,
    apiTimeEnd,
    platformId,
  });
};

const updatePreCheck = ({
  id,
  minAge,
  maxAge,
  cityList,
  optionalList,
  preclusiveList,
  apiTimeStart,
  apiTimeEnd,
}) => {
  return http.json_post("/manager/platform/updatePreCheck", {
    id,
    minAge,
    maxAge,
    cityList,
    optionalList,
    preclusiveList,
    apiTimeStart,
    apiTimeEnd,
  });
};

const deletePreCheck = ({ id }) => {
  return http.json_post("/manager/platform/deletePreCheck", {
    id,
  });
};

// 添加
const updateIndex = ({ platformList }) => {
  return http.json_post("/manager/platform/updateIndex", {
    platformList,
  });
};

const enable = ({ id, enabled }) => {
  return http.json_post("/manager/platform/enable", {
    id,
    enabled,
  });
};

// 编辑
const update = ({
  id,
  name,
  haveCallback,
  haveReturnUrl,
  exclusive,
  remark,
  needQueryResult,
  apiTimeStart,
  apiTimeEnd,
}) => {
  return http.json_post("/manager/platform/update", {
    id,
    name,
    haveCallback,
    haveReturnUrl,
    exclusive,
    remark,
    needQueryResult,
    apiTimeStart,
    apiTimeEnd,
  });
};

const updatePreCheckCity = ({ platformId, preclusiveList, optionalList }) => {
  return http.json_post("/manager/platform/updatePreCheckCity", {
    platformId,
    preclusiveList,
    optionalList,
  });
};

const updateInfo = ({ id, qualificationPlatformInfo }) => {
  return http.json_post("/manager/platform/updateInfo", {
    id,
    qualificationPlatformInfo,
  });
};

const paramList = ({ platformId }) => {
  return http.get("/manager/platform/paramList", {
    platformId,
  });
};

const addParam = ({ platformId, param, enabled, remark }) => {
  return http.json_post("/manager/platform/addParam", {
    platformId,
    param,
    enabled,
    remark,
  });
};

const updateParam = ({ id, param }) => {
  return http.json_post("/manager/platform/updateParam", { id, param });
};

const enableParam = ({ id, enabled }) => {
  return http.json_post("/manager/platform/enableParam", { id, enabled });
};

const changeDefaultParam = ({ id }) => {
  return http.json_post("/manager/platform/changeDefaultParam", { id });
};

const deleteParam = ({ id }) => {
  return http.json_post("/manager/platform/deleteParam", { id });
};

export default {
  queryPage,
  updateIndex,
  update,
  areaList,
  queryImageList,
  passRate,
  updateInfo,
  getPreCheckCity,
  updatePreCheckCity,
  getPreCheckList,
  addPreCheck,
  updatePreCheck,
  deletePreCheck,
  enable,
  paramList,
  addParam,
  updateParam,
  enableParam,
  changeDefaultParam,
  deleteParam,
};
